export default "__VITE_ASSET__CShQCU$v__"